<template>
    <div class="sbsCompany">
        <div class="sbsCompany__filters">
            <div class="sbsCompany__filter">
                <q-input v-model="filters.search" @update:model-value="(value) => onFiltersChange('search', value)"
                    outlined dense placeholder="Поиск по названию..." clearable debounce="500">
                    <template v-slot:prepend>
                        <q-icon name="search" />
                    </template>
                </q-input>
            </div>
            <div class="sbsCompany__filter">
                <q-input v-model="filters.guid_search"
                    @update:model-value="(value) => onFiltersChange('guid_search', value)" outlined dense
                    placeholder="Поиск по guid" clearable debounce="500">
                    <template v-slot:prepend>
                        <q-icon name="search" />
                    </template>
                </q-input>
            </div>
        </div>

        <CustomTable title="Сводная по СБС компаниям" :rowsData="this.rowsData" :columns="sbsCompanyTableColumns"
            :stickyHeader="true" :loading="isFetching" :custom-body="true" :small="true" :height="300"
            :showPagination="true" :pagesNumber="pagesNumber" :count="totalRecords"
            :onPaginationChange="handlePaginationChange">
            <template #top-right>
                <slot name="top-right">
                    <q-btn :loading="isFetching" @click="refetch" color="primary" size="sm">
                        <q-icon name="replay" />
                    </q-btn>
                </slot>
            </template>

            <template #customBody="props" v-if="!isFetching">
                <q-tr>
                    <custom-table-cell align="center" vertical-align="center" width="130px">
                        {{ props.row.sbs_company_id }}
                    </custom-table-cell>

                    <custom-table-cell align="left" vertical-align="center">
                        <span>{{ props.row.naimenovanie }}</span>
                        <br>
                        <span style="font-size: 10px;">Полное наименование: {{ props.row.naimenovanie_polnoe }}</span>
                    </custom-table-cell>

                    <custom-table-cell align="left" vertical-align="center" style="font-size: 11px;">
                        {{ props.row.key__ssylka }}
                    </custom-table-cell>

                    <custom-table-cell align="left" vertical-align="center" style="font-size: 11px;">
                        {{ props.row.ssylka__id }}
                    </custom-table-cell>

                    <custom-table-cell align="left" vertical-align="center">
                        {{ props.row.osnovnoy_vid_deyatelnosti__view }}
                    </custom-table-cell>

                    <custom-table-cell align="center" vertical-align="center">
                        {{ props.row.identifikatsionnyy_nomer }}
                    </custom-table-cell>

                    <custom-table-cell align="center" vertical-align="center">
                        {{ formatDate(props.row.data_svidetelstva_po_nds) }}
                    </custom-table-cell>

                    <custom-table-cell align="center" vertical-align="center">
                        {{ formatDate(props.row.date_modified, true) }}
                    </custom-table-cell>

                    <custom-table-cell align="center" vertical-align="center">
                        {{ formatDate(props.row.updated_at, true) }}
                    </custom-table-cell>
                </q-tr>
            </template>
        </CustomTable>
    </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import {
    getSbsCompanyList,
    sbsCompanyTableColumns,
} from "@/views/sbsCompany/services";
import { formatDate } from "@/utils/formatDate";

export default {
    name: "SbsCompany",
    components: { CustomTableCell, CustomTable },
    data() {
        return {
            sbsCompanyTableColumns,
            rowsData: [],
            totalRecords: 0,
            isFetching: false,
            pagination: {
                page: 1,
                limit: 30,
            },
            filters: {
                search: '',
                guid_search: ''
            },
        }
    },
    methods: {
        formatDate,
        async getData() {
            this.isFetching = true
            const queryParams = {
                ...this.filters,
                page: this.pagination.page,
                limit: this.pagination.limit,
            }
            const res = await getSbsCompanyList(queryParams)
            if (!res) return;
            this.isFetching = false
            this.rowsData = res?.data || []
            this.totalRecords = res?.total || 0
        },
        handlePaginationChange(newPage) {
            this.pagination.page = newPage;
            this.getData();
        },
        onFiltersChange(key, value) {
            this.filters[key] = value;
            this.pagination.page = 1;
            this.getData();
        },
        refetch() {
            this.getData();
        },
    },
    computed: {
        pagesNumber() {
            return Math.ceil(this.totalRecords / this.pagination.limit);
        },
    },
    mounted() {
        this.getData()
    },
}
</script>

<style scoped lang="scss">
.sbsCompany {
    height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;
}

.sbsCompany__filters {
    margin-bottom: 25px;
    display: flex;
    gap: 20px;
    align-items: flex-end;

    .sbsCompany__filter {
        width: 250px;
    }
}
</style>